{
  "optionsBoard": {
    "errors": {
      "couldNotGetOptions": "Couldn't get options"
    }
  }
}
